import { cn } from '@/shared/lib/utils'
import type { NegotiationPropertySummary } from '../../utils/resolve-negotiation-property'
import { resolveNegotiationProperty } from '../../utils/resolve-negotiation-property'

type CellNegotiationPropertyProps = {
  property?: NegotiationPropertySummary | null
  previousProperty?: NegotiationPropertySummary | null
  projectName?: string | null
  societyName?: string | null
  className?: string
}

export function HistoricalPropertyBadge() {
  return (
    <span
      className="shrink-0 rounded-sm border border-amber-300/70 bg-amber-50 px-1.5 py-0.5 text-[10px] font-semibold text-amber-700 dark:border-amber-700/70 dark:bg-amber-950/40 dark:text-amber-300"
      title="Inmueble histórico de una negociación rescindida"
    >
      Histórico
    </span>
  )
}

export function CellNegotiationProperty({
  property,
  previousProperty,
  projectName,
  societyName,
  className
}: CellNegotiationPropertyProps) {
  const display = resolveNegotiationProperty(property, previousProperty)
  const contextLabel = [projectName, societyName].filter(Boolean).join(' · ')

  return (
    <div className={cn('flex min-w-[210px] flex-col gap-0.5 py-1', className)}>
      <div className="flex min-w-0 items-center gap-1.5">
        <span
          className={cn(
            'min-w-0 truncate font-medium',
            display.isHistorical && 'text-muted-foreground line-through decoration-1'
          )}
          title={display.label}
        >
          {display.label}
        </span>
        {display.isHistorical ? <HistoricalPropertyBadge /> : null}
      </div>
      <span className="truncate text-xs text-muted-foreground" title={contextLabel || undefined}>
        {contextLabel || 'Sin proyecto o sociedad'}
      </span>
    </div>
  )
}
